<template>
  <a-modal v-model="visible" title="" onOk="handleOk" width="750px" @cancel="$emit('close')" :footer="null">
    <div class="mt-4">
      {{ test }}
      <h4 class="font-weight-bolder text-left kova-text">
        {{ test.Name }}
      </h4>
      <p class="text-left">
        {{ question.Description }}
      </p>
      <hr />
      <div class="row mt-4">
        <div class="col-1 text-right">
          <font-awesome-icon
            class="kova-text"
            style="font-size:20px"
            icon="circle"
          ></font-awesome-icon>
        </div>
        <div class="col">
          <p class="text-left font-weight-bold">
            {{ testLevel }} Level
          </p>
        </div>
      </div>
      <div class="row">
        <div class="col-1 text-right">
          <font-awesome-icon
            class="kova-text"
            style="font-size:20px"
            icon="comment-alt"
          ></font-awesome-icon>
        </div>
        <div class="col">
          <p class="text-left">
            {{ question.QuestionContent }}
          </p>
        </div>
      </div>
      <hr />
      <div class="text-left d-flex flex-wrap" v-if="question.Tags && question.Tags.length">
          <span
            class="bg-skills px-3 py-2 ml-3 mb-3 rounded text-size4"
            v-for="tag in question.Tags"
            :key="tag"
          >
            {{ tag }}</span
          >
        </div>
        <div class="text-center" v-else>
          There are no tags attached to this test
        </div>
     </div>
  </a-modal>
</template>

<script>
export default {
  computed: {
    testLevel() {
      return this.levels.find(key => key.id == this.test.Complexity)?.level;
    },
  },
  props: {
    visible: Boolean,
    question: {
      type: Object,
      default() {
        return {
          Complexity: '',
          Tags: [],
        }
      }
    },
    test: Object
  },
  methods: {
    onSelect(value) {
      this.date = value;
      this.interviewDate = value;
    },
    onPanelChange(value) {
      // console.log(value, mode);
      this.date = value;
      this.interviewDate = value;
    },
    getTime(time) {
      // console.log(time, timeString);
      this.time = time;
    },
  },
};
</script>
<style scoped>
  .bg-skills {
    background-color: #4bb38e;
    color: #fff;
  }
</style>
